(function() {
    'use strict';

    function SecurityForm() {
        this.$iframeWrap = $('#iframe_form');
        this.$iframe = $(document.getElementById('iframe_form').contentWindow.document);
        this.$ibody = this.$iframe.find('body');
        this.$idocument = this.$iframe.find('body');
        this.defaultHeisght = 1300;
        this.reserveSpace = 200;
        this.headerHeight = 60;
    }

    SecurityForm.prototype.init = function() {
        this.startListener();
    };

    SecurityForm.prototype.startListener = function() {
        $(this.$idocument).on(
            'click',
            function(event) {
                var $currentElem = $(event.target);

                if ($currentElem.hasClass('button') || $currentElem.hasClass('button-content')) {
                    this.updateHeight();
                    this.scrollToStartIframe();
                }
            }.bind(this)
        );
    };

    SecurityForm.prototype.updateHeight = function() {
        var $iform = this.$ibody.find('request-forms-form');

        this.$iframeWrap.height($iform.height() + this.reserveSpace);
    };

    SecurityForm.prototype.scrollToStartIframe = function() {
        var offsetTop = this.$iframeWrap.offset().top;

        $.scrollTo(offsetTop - this.headerHeight);
    };

    window.SecurityForm = SecurityForm;
})();



// WEBPACK FOOTER //
// ./assets/js/projects/security/includes/form.js